import { Container } from "reactstrap"

const MesOffres = () => {
  return (
    <div className="page-content">
      <Container fluid style={{ maxWidth: "100%" }}>
        <div className="page-title-box">hello</div>
      </Container>
    </div>
  )
}

export default MesOffres
